import { Decimal } from 'decimal.js';
/**
 * The price a Sale line is compared against for "below market price": the approval snapshot, the
 * Lines card chip and History all ask here, so a later discount (DISC-A4) subtracts what it applied
 * in this one place. Today it is the line's regular (base) price.
 */
export function lineMarketPrice(line) {
    return line.regularUnitPrice === null ? null : new Decimal(line.regularUnitPrice);
}
export function isBelowMarketPrice(unitPrice, marketPrice) {
    return marketPrice !== null && new Decimal(unitPrice).lessThan(marketPrice);
}
//# sourceMappingURL=line-market-price.js.map